/**
 * Formats a crypto address for display by showing first 6 and last 6 characters
 * @param address - The crypto address to format
 * @returns Formatted address like "0x86e9...682E71"
 */
export const formatAddress = (address: string): string => {
  if (!address || address.length < 12) {
    return address
  }

  const start = address.slice(0, 6)
  const end = address.slice(-6)
  return `${start}...${end}`
}
